import React, { useEffect, useState } from 'react';
import BackBtn from 'components/BackBtn';
import { useParams } from 'react-router-dom';
import { Button, Col, Form, Input, Row, Radio, Select } from 'antd';
import FloatBar from 'components/FloatBar';
import { useTranslation } from 'react-i18next';
import TdtSelect from 'components/TdtSelect';
import api from 'helpers/api.helper';
import { APP_URLS } from 'constants/url.constant';
import history from 'helpers/history.helper';
import { showNormal } from 'helpers/notification.helper';
import TdtButtonSubmit from 'components/TdtButtonSubmit';

const CreateFeedbackMessage = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const initialValues = { allow_reply_flag: true };

    const { id, reservationId } = useParams();

    const createMessage = async values => {
        values.module = 'counselor_thread';
        values.reservation_id = reservationId;
        values.user_id = id;
        const response = await api.post(APP_URLS.MESSAGE_THREADS_CREATE, values);
        if (response) {
            history.goBack();
            showNormal('', t('message:Your message has been sent'), 3);
        }
    };

    const [templates, setTemplates] = useState([]);
    const getTemplates = async () => {
        const res = await api.get(APP_URLS.MESSAGE_TEMPLATES);
        if (res && res.data && res.data.length > 0) {
            setTemplates(res.data);
        }
    };

    useEffect(() => {
        getTemplates().then(() => {});
    }, []);

    return (
        <div className="pl-44 pr-24 counselor-feedback-create-container">
            <BackBtn className=" back-btn-counselor" label={'フィードバックメッセージの作成'} />
            <p className="pink-color fs-14 mt-24 mb-32">{'*必須項目'}</p>
            <Form
                layout="vertical"
                form={form}
                initialValues={initialValues}
                onFinish={async values => {
                    await createMessage(values);
                }}
                requiredMark={false}
            >
                <Row gutter={16}>
                    <Col span={24} className="mb-8 d-none">
                        <Form.Item
                            name="message_template_id"
                            label={
                                <>
                                    メッセージテンプレート<span className="pink-color">*</span>
                                </>
                            }
                        >
                            <TdtSelect
                                style={{ width: 480 }}
                                size="large"
                                className="fs-14 select-gray"
                                onChange={value => {
                                    const objSelected = templates.find(t => t.id === value);
                                    form.setFieldsValue({
                                        title: objSelected.title,
                                        content: objSelected.content,
                                    });
                                }}
                            >
                                {templates.map(t => (
                                    <Select.Option key={t.id} value={t.id} style={{ height: 34 }}>
                                        <span className="fs-16 absolute-select">{t.name}</span>
                                        <span className="fs-10 text-gray-color absolute-select-description">
                                            医療相談の終了後に毎回送信するフィードバックの雛形です
                                        </span>
                                        {/*<div className="body1 mb-4">{t.name}</div>*/}
                                        {/*<div className="caption">{t.description}</div>*/}
                                    </Select.Option>
                                ))}
                            </TdtSelect>
                        </Form.Item>
                    </Col>
                    <Col span={24} className="mb-8">
                        <Form.Item
                            name="title"
                            label={
                                <>
                                    タイトル<span className="pink-color">*</span>
                                </>
                            }
                            validateTrigger={false}
                            rules={[
                                {
                                    required: true,
                                    message: t('validation:Please enter a valid {{field}}', {
                                        field: t('field:Title'),
                                    }),
                                },
                            ]}
                            style={{ maxWidth: 320 }}
                        >
                            <Input maxLength={255} />
                        </Form.Item>
                    </Col>
                    <Col span={24} className="mb-8">
                        <Form.Item
                            name="content"
                            label={
                                <>
                                    メッセージ<span className="pink-color">*</span>
                                </>
                            }
                            validateTrigger={false}
                            rules={[
                                {
                                    required: true,
                                    message: t('validation:Please enter a valid {{field}}', {
                                        field: t('field:Message'),
                                    }),
                                },
                            ]}
                            style={{ maxWidth: 480 }}
                        >
                            <Input.TextArea className="outline-explanation-input" />
                        </Form.Item>
                    </Col>
                    <Col span={24} className="mb-8">
                        <Form.Item
                            name="allow_reply_flag"
                            label={
                                <>
                                    相談者の返信を可能にするか<span className="pink-color">*</span>
                                </>
                            }
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Radio.Group>
                                <Radio value={true}>{'はい'}</Radio>
                                <Radio value={false}>{'いいえ'}</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>
                <FloatBar className="left-2side">
                    <TdtButtonSubmit type="primary" htmlType="submit" className="fw-b">
                        {t('Send')}
                    </TdtButtonSubmit>
                </FloatBar>
            </Form>
        </div>
    );
};

export default CreateFeedbackMessage;
